var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.chargesNewLayoutEnabled
    ? _c("sales-charges-module")
    : _c(
        "div",
        [
          _vm.loadingDetail
            ? _c(
                "div",
                { staticClass: "eu-pa_6 eu-align_center" },
                [_c("emd-loader", { attrs: { type: "_invert" } })],
                1
              )
            : _c(
                "div",
                { staticClass: "el-stripe" },
                [
                  _c("alert-reason-refusal", {
                    attrs: { data: _vm.charge.last_transaction },
                  }),
                  _c("br"),
                  _vm.alertSuccess.isOpen
                    ? _c(
                        "emd-alert",
                        {
                          attrs: {
                            variant: "success",
                            title: _vm.alertSuccess.title,
                          },
                          on: {
                            cancel: function ($event) {
                              _vm.alertSuccess.isOpen = false
                            },
                          },
                        },
                        [
                          _c("template", { slot: "content" }, [
                            _vm._v(
                              " " + _vm._s(_vm.alertSuccess.message) + " "
                            ),
                          ]),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.isCancelableBoletoSuccess
                    ? _c(
                        "emd-alert",
                        {
                          attrs: {
                            variant: "success",
                            title: _vm.$t(
                              "charge.detail.boleto-cancel.alert.success.title"
                            ),
                            autoclose: false,
                          },
                        },
                        [
                          _c("template", { slot: "content" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  this.$t(
                                    "charge.detail.boleto-cancel.alert.success.content"
                                  )
                                ) +
                                " "
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "emd-link underline",
                                attrs: {
                                  target: "_blank",
                                  rel: "noopener",
                                  href: "https://pagarme.helpjuice.com/p1-transa%C3%A7%C3%B5es-e-estornos/estorno-prazos-de-estorno-total-e-parcial?from_search=85003811",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "charge.detail.boleto-cancel.alert.success.content-link"
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c("charge-detail-table", {
                    ref: "chargeDetailTable",
                    attrs: {
                      charge: _vm.charge,
                      isCancelableBoleto: _vm.isCancelableBoleto,
                      canRetryCharge: _vm.canRetryCharge,
                      showAttemptButton: _vm.showAttemptButton,
                    },
                    on: {
                      resync: _vm.resync,
                      getLetter: _vm.getLetter,
                      openModalRefund: _vm.openModalRefund,
                      openRetryModal: _vm.openRetryModal,
                      openCaptureModal: _vm.openCaptureModal,
                      openConfirmModal: _vm.openConfirmModal,
                      openAttemptModal: _vm.openAttemptModal,
                      openModalSimulatorPayments:
                        _vm.openModalSimulatorPayments,
                    },
                  }),
                  _vm.showPayableInstallment
                    ? _c("recipients", {
                        attrs: {
                          splits: _vm.getSplits,
                          consolidated: _vm.getConsolidated,
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "eu-flex eu-justify_space-between" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "eu-flex-item eu-basis_12 eu-basis_6_lg eu-pr_3",
                        },
                        [
                          _c("transaction-summary", {
                            attrs: {
                              charge: _vm.charge,
                              isBoleto: _vm.isBoleto,
                              isPSP: _vm.isPSP,
                            },
                          }),
                          _vm.charge.last_transaction
                            ? _c("payment-method", {
                                attrs: {
                                  charge: _vm.charge,
                                  merchantId: _vm.merchantId,
                                  accountId: _vm.accountId,
                                },
                              })
                            : _vm._e(),
                          _vm.hasPayerPix
                            ? _c("payer-details", {
                                attrs: {
                                  payer: _vm.charge.last_transaction.payer,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "eu-flex-item eu-basis_12 eu-basis_6_lg eu-pl_3",
                        },
                        [
                          _c("TransactionTimeline", {
                            attrs: { transactions: _vm.charge.transactions },
                            on: { openDrawer: _vm.handleOpenDrawer },
                          }),
                          _vm.showMetadata
                            ? _c("Metadata", {
                                attrs: { metadata: _vm.charge.metadata },
                              })
                            : _vm._e(),
                          _c("log-links", {
                            attrs: {
                              entity: _vm.charge,
                              title: _vm.$t("log-links.charge"),
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c("last-log"),
                ],
                1
              ),
          _vm.attemptModal
            ? _c("modal-password", {
                attrs: { callback: _vm.attemptCharge },
                on: { cancel: _vm.closeModal },
              })
            : _vm._e(),
          _vm.cancelModal
            ? _c(
                "modal",
                { attrs: { open: _vm.cancelModal } },
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "emd-container _highlight_header _footer_end _footer_spaced_mobile",
                      },
                      [
                        _c("div", { staticClass: "emd-container__header" }, [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "emd-text _size_section _color_secondary",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("charge.detail.modal.cancel.title")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "emd-btn _type_link jsModalClose",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.cancelModal = false
                                },
                              },
                            },
                            [_c("i", { staticClass: "uil uil-times" })]
                          ),
                        ]),
                        _c(
                          "form",
                          {
                            attrs: { name: "cancelCharge", novalidate: "true" },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.cancelCharge.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "emd-container__content" },
                              [
                                _vm.alert.error
                                  ? _c(
                                      "emd-alert",
                                      {
                                        attrs: {
                                          variant: "danger",
                                          title: _vm.$t(
                                            "charge.detail.modal.cancel.error"
                                          ),
                                        },
                                        on: {
                                          cancel: function ($event) {
                                            _vm.alert.error = false
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "content" },
                                          _vm._l(
                                            _vm.errors,
                                            function (error, index) {
                                              return _c("p", { key: index }, [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(error.message) +
                                                    " "
                                                ),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _c("div", { staticClass: "emd-panel" }, [
                                  _c(
                                    "h2",
                                    { staticClass: "emd-text _size_section" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "charge.detail.modal.cancel.question"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "emd-panel" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "eu-flex eu-column eu-row_md eu-mb_4",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "eu-flex-item eu-basis_6_md",
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "emd-radio-button",
                                                attrs: {
                                                  for: "cancelTotal",
                                                  "data-children-count": "1",
                                                },
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.cancelTotal,
                                                      expression: "cancelTotal",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "emd-radio-button__input",
                                                  attrs: {
                                                    type: "radio",
                                                    id: "cancelTotal",
                                                  },
                                                  domProps: {
                                                    value: true,
                                                    checked: _vm._q(
                                                      _vm.cancelTotal,
                                                      true
                                                    ),
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      _vm.cancelTotal = true
                                                    },
                                                  },
                                                }),
                                                _c("div", {
                                                  staticClass:
                                                    "emd-radio-button__area",
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "emd-radio-button__text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "charge.detail.modal.cancel.total"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.canCancelPartial
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "eu-flex-item eu-basis_6_md",
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "emd-radio-button",
                                                    attrs: {
                                                      for: "cancelParcial",
                                                      "data-children-count":
                                                        "1",
                                                    },
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.cancelTotal,
                                                          expression:
                                                            "cancelTotal",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "emd-radio-button__input",
                                                      attrs: {
                                                        type: "radio",
                                                        id: "cancelParcial",
                                                      },
                                                      domProps: {
                                                        value: false,
                                                        checked: _vm._q(
                                                          _vm.cancelTotal,
                                                          false
                                                        ),
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          _vm.cancelTotal = false
                                                        },
                                                      },
                                                    }),
                                                    _c("div", {
                                                      staticClass:
                                                        "emd-radio-button__area",
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "emd-radio-button__text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "charge.detail.modal.cancel.partial"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    !_vm.cancelTotal && _vm.canCancelPartial
                                      ? _c("div", [
                                          _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "eu-flex" },
                                              [
                                                _vm.recipients.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "eu-flex-item",
                                                      },
                                                      [
                                                        _c(
                                                          "emd-form-group",
                                                          {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "charge.detail.modal.cancel.recipient"
                                                              ),
                                                              required: "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "emd-select",
                                                              {
                                                                model: {
                                                                  value:
                                                                    _vm.cancelRecipientId,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.cancelRecipientId =
                                                                        $$v
                                                                    },
                                                                  expression:
                                                                    "cancelRecipientId",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "option",
                                                                  {
                                                                    attrs: {
                                                                      value: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "charge.detail.modal.cancel.select"
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._l(
                                                                  _vm.recipients,
                                                                  function (
                                                                    recipient
                                                                  ) {
                                                                    return _c(
                                                                      "option",
                                                                      {
                                                                        key: recipient
                                                                          .split
                                                                          .recipient_gateway_id,
                                                                        domProps:
                                                                          {
                                                                            value:
                                                                              recipient
                                                                                .split
                                                                                .recipient_gateway_id,
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              recipient.name
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                              ],
                                                              2
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "eu-flex-item",
                                                  },
                                                  [
                                                    _c(
                                                      "emd-form-group",
                                                      {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "charge.detail.modal.cancel.amount"
                                                          ),
                                                          required: "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "emd-input-group",
                                                          },
                                                          [
                                                            _c(
                                                              "money",
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "emd-input",
                                                                  attrs: {
                                                                    type: "text",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.cancelAmount,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.cancelAmount =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "cancelAmount",
                                                                  },
                                                                },
                                                                "money",
                                                                _vm.money,
                                                                false
                                                              )
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _c("password-confirmation", {
                                      attrs: { label: null },
                                      model: {
                                        value: _vm.password,
                                        callback: function ($$v) {
                                          _vm.password = $$v
                                        },
                                        expression: "password",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "emd-container__footer" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "emd-btn _color_primary _type_text",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.cancelLoading,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.closeModal("cancelModal")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "charge.detail.modal.cancel.button-cancel"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "emd-btn _color_primary",
                                    attrs: {
                                      type: "submit",
                                      disabled:
                                        !_vm.password || _vm.cancelLoading,
                                    },
                                  },
                                  [
                                    _vm.cancelLoading
                                      ? _c("emd-loader", {
                                          attrs: { type: "" },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "charge.detail.modal.cancel.button-ok"
                                              )
                                            )
                                          ),
                                        ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _vm.captureModal
            ? _c(
                "modal",
                { attrs: { open: _vm.openCaptureModal || _vm.captureModal } },
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "emd-container _highlight_header _footer_end _footer_spaced_mobile",
                      },
                      [
                        _c("div", { staticClass: "emd-container__header" }, [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "emd-text _size_section _color_secondary",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("charge.detail.modal.capture.title")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "emd-btn _type_link jsModalClose",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.captureModal = false
                                },
                              },
                            },
                            [_c("i", { staticClass: "uil uil-times" })]
                          ),
                        ]),
                        _c(
                          "form",
                          {
                            attrs: {
                              name: "captureCharge",
                              novalidate: "true",
                            },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.captureCharge.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "emd-container__content" },
                              [
                                _vm.alert.error
                                  ? _c(
                                      "emd-alert",
                                      {
                                        attrs: {
                                          variant: "danger",
                                          title: _vm.$t(
                                            "charge.detail.modal.capture.error"
                                          ),
                                        },
                                        on: {
                                          cancel: function ($event) {
                                            _vm.alert.error = false
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "content" },
                                          _vm._l(
                                            _vm.errors,
                                            function (error, index) {
                                              return _c("p", { key: index }, [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(error.message) +
                                                    " "
                                                ),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _c("div", { staticClass: "emd-panel" }, [
                                  _c(
                                    "h2",
                                    { staticClass: "emd-text _size_section" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "charge.detail.modal.capture.question"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "emd-panel" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "eu-flex eu-column eu-row_md eu-mb_4",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "eu-flex-item eu-basis_6_md",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "emd-form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "emd-radio-button",
                                                    attrs: {
                                                      for: "captureTotal",
                                                      "data-children-count":
                                                        "1",
                                                    },
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.captureTotal,
                                                          expression:
                                                            "captureTotal",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "emd-radio-button__input",
                                                      attrs: {
                                                        type: "radio",
                                                        id: "captureTotal",
                                                      },
                                                      domProps: {
                                                        value: true,
                                                        checked: _vm._q(
                                                          _vm.captureTotal,
                                                          true
                                                        ),
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          _vm.captureTotal = true
                                                        },
                                                      },
                                                    }),
                                                    _c("div", {
                                                      staticClass:
                                                        "emd-radio-button__area",
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "emd-radio-button__text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "charge.detail.modal.capture.total"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "eu-flex-item eu-basis_6_md",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "emd-form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "emd-radio-button",
                                                    attrs: {
                                                      for: "captureParcial",
                                                      "data-children-count":
                                                        "1",
                                                    },
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.captureTotal,
                                                          expression:
                                                            "captureTotal",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "emd-radio-button__input",
                                                      attrs: {
                                                        type: "radio",
                                                        id: "captureParcial",
                                                      },
                                                      domProps: {
                                                        value: false,
                                                        checked: _vm._q(
                                                          _vm.captureTotal,
                                                          false
                                                        ),
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          _vm.captureTotal = false
                                                        },
                                                      },
                                                    }),
                                                    _c("div", {
                                                      staticClass:
                                                        "emd-radio-button__area",
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "emd-radio-button__text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "charge.detail.modal.capture.partial"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    !_vm.captureTotal
                                      ? _c("div", [
                                          _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "emd-form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "emd-label _required",
                                                    attrs: {
                                                      for: "money-capture",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "charge.detail.modal.capture.amount"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "emd-input-group",
                                                  },
                                                  [
                                                    _c(
                                                      "money",
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "emd-input",
                                                          attrs: {
                                                            id: "money-capture",
                                                            type: "text",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.captureAmount,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.captureAmount =
                                                                $$v
                                                            },
                                                            expression:
                                                              "captureAmount",
                                                          },
                                                        },
                                                        "money",
                                                        _vm.money,
                                                        false
                                                      )
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _c("password-confirmation", {
                                      attrs: { label: null },
                                      model: {
                                        value: _vm.password,
                                        callback: function ($$v) {
                                          _vm.password = $$v
                                        },
                                        expression: "password",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "emd-container__footer" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "emd-btn _color_primary _type_text",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.captureLoading,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.closeModal("captureModal")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "charge.detail.modal.capture.button-cancel"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "emd-btn _color_primary",
                                    attrs: {
                                      type: "submit",
                                      disabled:
                                        !_vm.password || _vm.captureLoading,
                                    },
                                  },
                                  [
                                    _vm.captureLoading
                                      ? _c("emd-loader", {
                                          attrs: { type: "" },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "charge.detail.modal.capture.button-ok"
                                              )
                                            )
                                          ),
                                        ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _vm.confirmModal
            ? _c(
                "modal",
                { attrs: { open: _vm.confirmModal || _vm.openConfirmModal } },
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "emd-container _highlight_header _footer_end _footer_spaced_mobile",
                      },
                      [
                        _c("div", { staticClass: "emd-container__header" }, [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "emd-text _size_section _color_secondary",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("charge.detail.modal.confirm.title")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "emd-btn _type_link jsModalClose",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.confirmModal = false
                                },
                              },
                            },
                            [_c("i", { staticClass: "uil uil-times" })]
                          ),
                        ]),
                        _c(
                          "form",
                          {
                            attrs: {
                              name: "confirmCharge",
                              novalidate: "true",
                            },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.confirmCharge.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "emd-container__content" },
                              [
                                _vm.alert.error
                                  ? _c(
                                      "emd-alert",
                                      {
                                        attrs: {
                                          variant: "danger",
                                          title: _vm.$t(
                                            "charge.detail.modal.confirm.error"
                                          ),
                                        },
                                        on: {
                                          cancel: function ($event) {
                                            _vm.alert.error = false
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "content" },
                                          _vm._l(
                                            _vm.errors,
                                            function (error, index) {
                                              return _c("p", { key: index }, [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(error.message) +
                                                    " "
                                                ),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "emd-panel" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "emd-panel__section" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "emd-panel__block" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "emd-form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "emd-label _required",
                                                    attrs: {
                                                      for: "money-confirm",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "charge.detail.modal.confirm.amount"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "emd-input-group",
                                                  },
                                                  [
                                                    _c(
                                                      "money",
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "emd-input",
                                                          attrs: {
                                                            id: "money-confirm",
                                                            type: "text",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.confirmAmount,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.confirmAmount =
                                                                $$v
                                                            },
                                                            expression:
                                                              "confirmAmount",
                                                          },
                                                        },
                                                        "money",
                                                        _vm.money,
                                                        false
                                                      )
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("password-confirmation", {
                                      model: {
                                        value: _vm.password,
                                        callback: function ($$v) {
                                          _vm.password = $$v
                                        },
                                        expression: "password",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "emd-container__footer" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "emd-btn _color_primary _type_text",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.confirmLoading,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.closeModal("confirmModal")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "charge.detail.modal.confirm.button-cancel"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "emd-btn _color_primary",
                                    attrs: {
                                      type: "submit",
                                      disabled:
                                        !_vm.password || _vm.confirmLoading,
                                    },
                                  },
                                  [
                                    _vm.confirmLoading
                                      ? _c("emd-loader", {
                                          attrs: { type: "" },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "charge.detail.modal.confirm.button-ok"
                                              )
                                            )
                                          ),
                                        ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _vm.letterModal
            ? _c(
                "modal",
                { attrs: { open: _vm.letterModal } },
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "emd-container _highlight_header _footer_end",
                      },
                      [
                        _c("div", { staticClass: "emd-container__header" }, [
                          _c(
                            "h2",
                            {
                              staticClass:
                                "emd-text _size_section _color_secondary",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    this.$t(
                                      `charge.detail.modal.letter.${_vm.letterType}-letter`
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "emd-btn _type_link jsModalClose",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.closeModal("letterModal")
                                },
                              },
                            },
                            [_c("i", { staticClass: "uil uil-times" })]
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "emd-container__content" },
                          [
                            _vm.showLetterAlert && !_vm.alert.error
                              ? _c(
                                  "emd-alert",
                                  {
                                    attrs: {
                                      variant: "warning",
                                      autoclose: false,
                                      title: _vm.$t(
                                        `charge.detail.modal.letter.${_vm.letterType}-warning-title`
                                      ),
                                    },
                                    on: {
                                      cancel: function ($event) {
                                        _vm.showLetterAlert = false
                                      },
                                    },
                                  },
                                  [
                                    _c("template", { slot: "content" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "charge.detail.modal.letter.warning-text"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            !_vm.alert.error
                              ? _c(
                                  "div",
                                  { staticClass: "eu-align_center eu-pa_3" },
                                  [
                                    _c("emd-loader", {
                                      attrs: { type: "_invert" },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.alert.error
                              ? _c(
                                  "emd-alert",
                                  {
                                    attrs: {
                                      variant: "danger",
                                      title: _vm.$t(
                                        `charge.detail.modal.letter.${_vm.letterType}-error-title`
                                      ),
                                    },
                                    on: {
                                      cancel: function ($event) {
                                        _vm.alert.error = false
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "content" },
                                      _vm._l(
                                        _vm.errors,
                                        function (error, index) {
                                          return _c("p", { key: index }, [
                                            _vm._v(
                                              " " + _vm._s(error.message) + " "
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _vm.chargeReady && _vm.canRetryCharge
            ? _c("modal-charge-reprocess", {
                attrs: {
                  charge: _vm.charge,
                  isOpen: _vm.retryModal,
                  error: _vm.retryError,
                  isLoad: _vm.retryLoading,
                  antifraudEnabled: _vm.hasRetryWithAntifraud,
                },
                on: {
                  submit: _vm.retry,
                  close: function ($event) {
                    return _vm.closeModal("retryModal")
                  },
                },
              })
            : _vm._e(),
          _vm.showBoletoCancelModal
            ? _c(
                "boleto-cancel-modal",
                {
                  attrs: { open: _vm.boletoCancelModal },
                  on: { close: _vm.closeBoletoCancelModal },
                },
                [
                  _c("boleto-cancel", {
                    attrs: {
                      totalAmount: _vm.getAvailableAmountToBoletoCancel,
                      split: _vm.getSplits,
                      chargeId: _vm.charge.id,
                    },
                    on: {
                      close: _vm.closeBoletoCancelModal,
                      success: _vm.refreshPage,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.showSimulatorPaymentsModal
            ? _c("simulate-payments-modal", {
                attrs: {
                  open: _vm.showSimulatorPaymentsModal,
                  name: _vm.charge.customer.name,
                  email: _vm.charge.customer.email,
                  value: _vm.charge.amount,
                  transactionId: _vm.charge?.pgid,
                },
                on: { handleClose: _vm.closeSimulatorPaymentsModal },
              })
            : _vm._e(),
          _vm.drawer.open
            ? _c("TransactionDetails", {
                attrs: {
                  open: _vm.drawer.open,
                  data: _vm.drawer.data,
                  entity: _vm.charge,
                },
                on: {
                  "update:open": function ($event) {
                    return _vm.$set(_vm.drawer, "open", $event)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "log",
                      fn: function () {
                        return [
                          _vm.showLogLinks
                            ? _c("log-links", {
                                attrs: {
                                  title: _vm.$t("log-links.transaction"),
                                  isSection: false,
                                  entity: _vm.charge,
                                  noPadding: "",
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2667883193
                ),
              })
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }